import { checkAuthorization } from "./authorize";

const bindings = {
	pattern: "<",
	action: "<",
	actionOrPattern: "<",
	actionScope: "<"
};

const controller = function(securityService) {
	this.isAllowed = false;

	this.check = () => {
		this.isAllowed = checkAuthorization(securityService, {
			authorizePattern: this.pattern, 
			authorizeAction: this.action, 
			authorizeActionOrPattern: this.actionOrPattern, 
			authorizeActionScope: this.actionScope 
		});
	};

	this.$onChanges = (changes) => {
		if(changes.pattern || changes.action || changes.actionOrPattern || changes.actionScope) {
			this.check();  
		}
	};

	this.check();
};

const template = `
	<div ng-if="$ctrl.isAllowed">
		<ng-transclude></ng-transclude>
	</div>
`;

const authorizeComponent = angular
	.module("vesl.behaviors.authorize.component", [])
	.component("ifAuthorized", {
		bindings, 
		controller,
		template,
		transclude: true
	})
	.name;

export { authorizeComponent };
